module.exports = __webpack_public_path__ + "img/1017_sp.a707495e.gif";